import React, { useState } from 'react';
import './Contact.css';
import { FaLinkedin, FaGithub, FaKey, FaEnvelope } from 'react-icons/fa';
import { SiPackagist } from 'react-icons/si';

function Contact() {
  const [showPGPKey, setShowPGPKey] = useState(false);

  const pgpPublicKey = `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=4ODC
-----END PGP PUBLIC KEY BLOCK-----`;

  return (
    <section className="contact">
      <div className="container">
        <h2><FaEnvelope className="section-icon"/> Get In Touch</h2>
        <p className="contact-intro">
          I'm always open to discussing new projects, opportunities, or collaborations.
        </p>
        <div className="contact-links">
          <a href="https://linkedin.com/in/sambrereton" target="_blank" rel="noopener noreferrer"
             className="contact-link">
            <FaLinkedin className="icon"/>
            <span>LinkedIn</span>
          </a>
          <a href="https://github.com/sbrereton" target="_blank" rel="noopener noreferrer" className="contact-link">
            <FaGithub className="icon"/>
            <span>GitHub</span>
          </a>
          <a href="https://packagist.org/users/sbrereton" target="_blank" rel="noopener noreferrer"
             className="contact-link">
            <SiPackagist className="icon"/>
            <span>Packagist</span>
          </a>
        </div>

        <div style={{textAlign: 'center', margin: '2rem auto', maxWidth: '1200px'}}>
          <a href="https://sambrereton.net.au/assets/resume.pdf" target="_blank" rel="noopener noreferrer"
             className="resume-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
            Download Resume as PDF
          </a>
        </div>

        <div className="pgp-section">
          <h3>PGP Public Key</h3>
          <div className="pgp-badge" onClick={() => setShowPGPKey(!showPGPKey)} style={{cursor: 'pointer'}}>
            <FaKey className="pgp-icon"/>
            <div className="pgp-details">
              <span className="pgp-label">PGP:</span>
              <code className="pgp-hash">0x0CDE6F9B</code>
            </div>
          </div>

          {showPGPKey && (
              <div className="pgp-full-key">
                <pre>{pgpPublicKey}</pre>
                <button onClick={() => navigator.clipboard.writeText(pgpPublicKey)} className="copy-button">
                  Copy to Clipboard
                </button>
              </div>
          )}
        </div>

        <footer className="footer">
          <p>&copy; {new Date().getFullYear()} Samuel Brereton. All rights reserved.</p>
        </footer>
      </div>
    </section>
  );
}

export default Contact;
